import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function TkMaterialInputStatus ( props ) {

    return <BasicCrudScreenType id="TkMaterialInputStatus" view="TkVwMaterialInputStatus"/>;

}

export default TkMaterialInputStatus;
